/**
 * useNavigationConfig — Hook léger pour récupérer les onglets masqués
 * pour l'utilisateur courant (résolution rôle + override user côté backend).
 *
 * Usage :
 *   const { hiddenTabs, isHidden, loading } = useNavigationConfig();
 *   if (!isHidden('bibliotheque')) { ... render tab ... }
 *
 * V36.3 — 28/05/2026.
 */
import { useEffect, useState, useMemo, useCallback } from 'react';
import axios from 'axios';
import { getAuthHeader } from '../services/tokenService';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function useNavigationConfig() {
  const [hiddenTabs, setHiddenTabs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const headers = getAuthHeader();
    if (!headers.Authorization) {
      setLoading(false);
      return;
    }
    axios
      .get(`${API}/admin/navigation-config/me`, { headers })
      .then((r) => {
        if (!cancelled) setHiddenTabs(Array.isArray(r.data?.hidden_tabs) ? r.data.hidden_tabs : []);
      })
      .catch(() => { /* silently default to visible */ })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const hiddenSet = useMemo(() => new Set(hiddenTabs), [hiddenTabs]);
  const isHidden = useCallback((tabKey) => hiddenSet.has(tabKey), [hiddenSet]);

  return { hiddenTabs, isHidden, loading };
}
